import React, { FC } from 'react';
import cn from 'clsx';

import { ChevronRightIcon } from '../Icons';

export interface StatCardProps extends React.ComponentPropsWithoutRef<'div'> {
  className?: string;
  iconCn?: string;
  label: string;
  value: string;
}

export const StatCard: FC<StatCardProps> = ({
  label,
  value,
  className,
  iconCn,
  ...props
}) => {
  return (
    <div
      className={cn(
        'group flex flex-col py-4 px-4 space-y-1 bg-white',
        className
      )}
      {...props}
      role={props.role || props.onClick ? 'button' : undefined}
    >
      <div className="font-semibold">{label}</div>
      <div className="flex flex-col justify-end flex-grow text-5xl font-semibold">
        <div className="flex items-center">
          <span className="flex-grow">{value}</span>{' '}
          <ChevronRightIcon className={iconCn} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
